// Parent dashboard: gentle deadline nudges for SAVED opportunities — same
// verified-deadline selection as the weekly digest (never invented dates).
// Dismissing hides a listing for its CURRENT deadline only.
import { useEffect, useState } from "react";
import { CalendarClock, X } from "lucide-react";
import { api } from "../../lib/api";

const daysLabel = (n) => (n === 0 ? "due today"
  : n === 1 ? "1 day left" : `${n} days left`);

export const DeadlineNudgeCard = () => {
  const [nudges, setNudges] = useState([]);
  useEffect(() => {
    api.get("/opportunities/deadline-nudges")
      .then(({ data }) => setNudges(data.nudges || []))
      .catch(() => setNudges([]));
  }, []);
  const dismiss = (id) => {
    setNudges((n) => n.filter((x) => x.opportunity_id !== id));
    api.post(`/opportunities/${id}/dismiss-nudge`).catch(() => {});
  };
  if (!nudges.length) return null;
  return (
    <section className="bg-amber-50 rounded-2xl border border-amber-300 p-4"
      data-testid="deadline-nudge-card">
      <h2 className="text-sm font-bold font-display flex items-center gap-2 text-amber-950 mb-2">
        <CalendarClock className="h-4 w-4 text-amber-600" aria-hidden="true" />
        Saved deadlines coming up
      </h2>
      <div className="space-y-1.5">
        {nudges.map((n) => (
          <div key={n.opportunity_id}
            className="flex items-center justify-between gap-2 rounded-xl bg-white border border-amber-200 px-3 py-2"
            data-testid={`deadline-nudge-${n.opportunity_id}`}>
            <button type="button"
              onClick={() => window.location.assign(`/opportunities?tab=saved&focus=${n.opportunity_id}`)}
              className="text-left text-sm text-amber-950 min-w-0 hover:underline decoration-amber-400"
              data-testid={`deadline-nudge-open-${n.opportunity_id}`}>
              <span className="font-bold">{n.title}</span>
              <span className="text-amber-800/80"> — {n.organization} · </span>
              <span className={`font-bold ${n.days_left <= 3 ? "text-rose-700" : "text-amber-800"}`}
                data-testid={`deadline-nudge-days-${n.opportunity_id}`}>
                {daysLabel(n.days_left)} ({n.deadline})
              </span>
            </button>
            <button type="button" onClick={() => dismiss(n.opportunity_id)}
              aria-label={`Dismiss reminder for ${n.title}`}
              className="shrink-0 rounded-full p-1.5 text-amber-700 hover:bg-amber-100"
              data-testid={`deadline-nudge-dismiss-${n.opportunity_id}`}>
              <X className="h-4 w-4" aria-hidden="true" />
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};
